module.exports = __webpack_public_path__ + "img/logo.ed69149a.svg";